import { z } from 'zod'
import { FreeTextCitedFactSchema, StructuredCitedFactSchema } from './citedFact'

export const ARTEFACT_FIELD_REFS = [
  'artefact.status',
  'artefact.source_url',
  'artefact.valid_from',
  'artefact.period_end',
  'artefact.summary',
] as const
export const ArtefactFieldRefSchema = z.enum(ARTEFACT_FIELD_REFS)
export type ArtefactFieldRef = z.infer<typeof ArtefactFieldRefSchema>

// By `requestArtefactId`, not the `supplier_artefact:N` handle: a handle must stay a file `readDocument` can open.
export const SupplierArtefactCitationAgentInputSchema = z.object({
  type: z.literal('supplier_artefact'),
  requestArtefactId: z.string().describe('The requestArtefactId shown on the supplier artefact inventory line being cited'),
  fieldRef: ArtefactFieldRefSchema.describe('Which fact on the supplier artefact inventory line is being cited.'),
  anchor: z
    .string()
    .trim()
    .min(1)
    .nullable()
    .describe(
      'Verbatim phrase from the cited field, or null. Set this only for `artefact.summary`, when the answer spans more than one sentence or roughly 20 words of it and citing the whole summary would be too broad; otherwise null.'
    ),
})

const StructuredCitedArtefactFactSchema = z.strictObject({
  ...StructuredCitedFactSchema.shape,
  fieldRef: ArtefactFieldRefSchema,
})
export const CitedArtefactFactSchema = z.discriminatedUnion('kind', [StructuredCitedArtefactFactSchema, FreeTextCitedFactSchema])
export type CitedArtefactFact = z.infer<typeof CitedArtefactFactSchema>

// One citation per artefact: the agent cites one field per input, and the fold stacks them in `citedFacts`.
export const SupplierArtefactCitationResolvedSchema = z.object({
  sourceType: z.literal('supplier_artefact'),
  sourceLabel: z.string(),
  requestId: z.string(),
  requestArtefactId: z.string(),
  artefactTypeId: z.string(),
  // The artefact's own link, whichever fact is cited: a record with no stored file has no other way to open it.
  sourceUrl: z.string().optional(),
  citedFacts: z.array(CitedArtefactFactSchema).min(1),
})
export type SupplierArtefactCitationResolved = z.infer<typeof SupplierArtefactCitationResolvedSchema>
